module.exports = __webpack_public_path__ + "static/media/Clean-Steel.2d086cd4.svg";